module.exports = __webpack_public_path__ + "static/green-channel.5133163b.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/green-channel.png
// module id = 981
// module chunks = 2